"use client";

import { useCallback, useRef, useState } from "react";

import { BrandContextMenu } from "@/components/brand-context-menu";
// import { ChanhDaiMark } from "@/components/chanhdai-mark";
import { SonnyMark } from "@/components/sonny-mark";
import { cn } from "@/lib/utils";

import { CoverVideo } from "./cover-video";

export function ProfileCover() {
  // Tracks whether footage is on screen right now — not merely whether it once
  // played — so the mark never sits white over the light pattern.
  const [playing, setPlaying] = useState(false);
  const playingRef = useRef(false);

  const onPlaying = useCallback(() => {
    playingRef.current = true;
  }, []);

  const onVisibleChange = useCallback((visible: boolean) => {
    setPlaying(visible);
  }, []);

  return (
    <BrandContextMenu>
      <div
        className={cn(
          "relative overflow-hidden",
          "aspect-2/1 border-x border-edge select-none sm:aspect-3/1",
          "flex items-center justify-center",
          "screen-line-before screen-line-after before:-top-px after:-bottom-px",
          "bg-black/0.75 bg-[radial-gradient(var(--pattern-foreground)_1px,transparent_0)] bg-size-[10px_10px] bg-center [--pattern-foreground:var(--color-zinc-950)]/5 dark:bg-white/0.75 dark:[--pattern-foreground:var(--color-white)]/5",
          // Over footage the mark is always white — including light mode.
          // Without footage it goes back to theme-aware, so it stays visible
          // against the light dot pattern.
          playing ? "text-white" : "text-black dark:text-white"
        )}
      >
        <CoverVideo onPlaying={onPlaying} onVisibleChange={onVisibleChange} />

        <SonnyMark
          id="js-cover-mark"
          className={cn(
            "relative h-1/4 w-auto transition-[color,filter] duration-500",
            playing && "drop-shadow-[0_2px_12px_rgba(0,0,0,0.55)]"
          )}
        />
      </div>
    </BrandContextMenu>
  );
}
